import styled, { css } from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  background: var(--white-dark);
  display: flex;
  flex-direction: column;

  .animal-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  @media (max-width: 800px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px 30%;

  @media (max-width: 800px) {
    padding: 32px 24px;
  }
`;

export const Card = styled.button`
  display: flex;
  align-items: center;

  width: 100%;
  margin-bottom: 20px;

  background: var(--white-darker);
  color: var(--black-3);
  font-size: 16px;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;

  > svg {
    margin-right: 16px;
    min-width: 32px;
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    text-align: left;

    > strong {
      width: 80%;
    }

    > p {
      font-size: 14px;
    }
  }
`;
